import {Matcher} from '@/lib/axiosAddTransforms'

const matchers: Matcher[] = [
  {
    test: /^\/invitations\/\$id\/?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {invitationId} = payload.params
        payload.url = `/invitations/${invitationId}`
        delete payload.params.invitationId
        delete payload.headers.Authorization
        return payload
      },
      response: (data) => {
        if(!data) {
          return data
        }
        return invitationResponse(data)
      },
    },
  },
  {
    test: /^\/invitations\/\$id\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {invitationId} = payload.params
        payload.url = `/invitations/${invitationId}`
        delete payload.params.invitationId
        return payload
      },
      response: (data) => {
        if(!data) {
          return data
        }
        return invitationResponse(data)
      },
    },
  },
  {
    test: /^\/invitations\/\$id\/send-auth-sms?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {invitationId} = payload.params
        payload.url = `/invitations/${invitationId}/send-auth-sms`
        delete payload.params.invitationId
        return payload
      },
      response: (data) => data
    },
  },
  {
    test: /^\/invitations\/\$id\/check-auth-sms?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {invitationId} = payload.params
        payload.url = `/invitations/${invitationId}/check-auth-sms`
        delete payload.params.invitationId
        return payload
      },
      response: (data) => data
    },
  },
]

const invitationResponse = (data) => {
  const {bizId = ''} = data
  return {
    ...data,
    bizId: String(bizId),
  }
}

export default matchers
